@if (vm()) {
  <ng-container>
    @if (vm()?.form) {
      <div [formGroup]="vm().form" class="video-capture-question">
        @for (videoSrc of vm().videoSrc; track videoSrc.id; let i = $index) {
          <question-video-player
            (recordingUpdated)="updateRecordedValue($event)"
      [params]="{
        canRecord: false,
        readOnly: false,
        qaHook: vm().key + 'VideoCapture' + i,
        type: 'video/mp4',
        videoClass: 'img-static-small',
        videoSource: videoSrc.src,
        id: videoSrc.id
      }"
          ></question-video-player>
          } @if (!vm().videoSrc.length) {
          <question-video-player
            (recordingUpdated)="updateRecordedValue($event)"
      [params]="{
        qaHook: vm().key + 'VideoCapture',
        type: 'video/mp4',
        videoClass: 'img-static-small'
      }"
          ></question-video-player>
        }
      </div>
    }
  </ng-container>
} @else {
  <jui-skeleton-loader color="info" inline="true" height="13px" width="100%" class="video-loading"></jui-skeleton-loader>
}
